import { useTranslation } from 'react-i18next';
import { FormItem } from '../../../../components/FormItem';
import { FormItemName } from '../../../../lib/models/Form';
import { FormInput } from '../../../../components/FormInput';

import styles from './index.module.scss';

const clientWebsite = 'unique.formItems.clientWebsite';

const url = 'unique.formItems.url';

import { ReactComponent as LinkIcon } from './../../../../assets/icons/link-icon-gray.svg';

export const ClientWebsiteFormItem = () => {
  const { t } = useTranslation();

  return (
    <FormItem
      name={FormItemName.CLIENT_WEBSITE}
      hasFeedback={true}
      rules={[
        {
          required: false,
        },
        {
          type: 'url',
          message: t(`${url}.errors.invalid`),
        },
        { max: 200 },
      ]}
    >
      <FormInput className={styles.inputUrl} icon={<LinkIcon />} label={t(`${clientWebsite}.label`)} />
    </FormItem>
  );
};
